const INITIAL_VALUES = {
  agentNum: '',
  agentName: '',
  plazas: [],
};

export default INITIAL_VALUES;
